import {
  SlotAvailabilityType,
  appointmentModeValueMapping,
  slotAvailabilityLabels,
} from 'app/Bookings/constants'
import classNames from 'classnames'
import { ReactElement, useEffect, useState } from 'react'
import styles from './index.module.scss'

interface VisitTypeCheckboxProps {
  handleAppointmentMode: (mode: SlotAvailabilityType) => void
  appointmentMode: SlotAvailabilityType
  availabilityLabels: SlotAvailabilityType[]
  containerClass?: string
  userSelectedAvailType?: ProviderFilter[]
  providerName: string
  titleText?: string
  showTitle?: boolean
  titleClass?: string
  onProfilePage?: boolean
}

const VisitTypeCheckbox = ({
  appointmentMode,
  handleAppointmentMode,
  availabilityLabels,
  providerName,
  containerClass,
  titleText = '',
  showTitle = true,
  titleClass = '',
  onProfilePage = false,
}: VisitTypeCheckboxProps): ReactElement => {
  const availabilityTypes = [
    SlotAvailabilityType.ONLINE,
    SlotAvailabilityType.INPERSON,
  ]
  const hasSingleTypeOfAvailability = availabilityLabels.length === 1
  const bothSessionActive = sessionStorage.getItem('bothSessionActive')
  const [inPersonActive, setInPersonActive] = useState(
    !!(appointmentMode === 'in_person' || bothSessionActive === 'true')
  )
  const [onlineActive, setOnlineActive] = useState(
    !!(appointmentMode === 'online' || bothSessionActive === 'true')
  )
  useEffect(() => {
    !onProfilePage && sessionStorage.removeItem('bothSessionActive')

    onProfilePage
      ? inPersonActive && onlineActive
        ? sessionStorage.setItem('bothSessionActive', 'true')
        : sessionStorage.setItem('bothSessionActive', 'false')
      : null
  }, [onProfilePage, inPersonActive, onlineActive])

  const appointmentValue =
    availabilityLabels[0] === 'online'
      ? appointmentModeValueMapping['Online'].split(' ')[0]
      : appointmentModeValueMapping['In Person']

  const checkActiveSession = (availability) => {
    return inPersonActive && onlineActive
      ? availability === 'in_person'
        ? 'online'
        : 'in_person'
      : availability
  }

  // This function will help with show and hide of the slots in the modal according to user's visit type selection instead of fetching them everytime.
  const handleCheckBoxClick = (availability) => {
    availability === 'in_person'
      ? setInPersonActive(!inPersonActive)
      : setOnlineActive(!onlineActive)
    handleAppointmentMode(
      appointmentMode === undefined
        ? checkActiveSession(availability)
        : undefined
    )
  }

  return (
    <div className={classNames(containerClass, styles.VisitTypeCheckbox)}>
      {hasSingleTypeOfAvailability ? (
        <div className={styles.VisitTypeCheckbox_singleSessionTypeMsg}>
          {providerName} is available for {appointmentValue} visits.
        </div>
      ) : (
        <>
          {showTitle && (
            <div
              className={classNames(
                styles.VisitTypeCheckbox_heading,
                titleClass
              )}
            >
              {titleText || 'What kind of visit would you like?'}
            </div>
          )}
          <div className={classNames(styles.VisitTypeCheckbox_container)}>
            {availabilityTypes.map((availability, availIndex) => {
              const availabilityTypeLabel = slotAvailabilityLabels[
                availability
              ].split(' ')[0]

              return (
                <div
                  key={`${availability}-${availIndex}`}
                  className={styles.VisitTypeCheckbox_container_checkbox}
                  onClick={() => handleCheckBoxClick(availability)}
                >
                  <div
                    className={classNames(
                      styles.VisitTypeCheckbox_container_checkbox_button,
                      {
                        [styles.VisitTypeCheckbox_container_checkbox_selected]:
                          availability === 'in_person'
                            ? inPersonActive
                            : onlineActive,
                      }
                    )}
                  />
                  <div
                    className={classNames(
                      styles.VisitTypeCheckbox_container_checkbox_label
                    )}
                  >
                    {availabilityTypeLabel}
                  </div>
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default VisitTypeCheckbox
